import hasPermi from './permission/hasPermi';
import hasRole from './permission/hasRole';

// eslint-disable-next-line func-names
const install = function (Vue) {
  Vue.directive('hasPermi', hasPermi);
  Vue.directive('hasRole', hasRole);
};

if (window.Vue) {
  window.hasPermi = hasPermi;
  window.hasRole = hasRole;
  Vue.use(install); // eslint-disable-line
}

export default install;



// WEBPACK FOOTER //
// ./src/directive/index.js